import RouterHolder from '@/components/router-holder'
import * as ConstantRouter from '@/constant/router'

const route = {
  path: 'experts-lib',
  name: ConstantRouter.DASHBOARD_EXPERTS_LIB,
  component: RouterHolder,
  redirect: '/admin/experts-lib',
  children: [
    {
      path: '',
      component: () =>
        import(
          /* webpackChunkName: "dashboard-experts-lib" */ '@/dashboard/experts-lib'
        )
    },
    {
      path: 'add',
      name: ConstantRouter.DASHBOARD_EXPERTS_LIB_ADD,
      component: () =>
        import(
          /* webpackChunkName: "dashboard-experts-lib-add" */ '@/dashboard/experts-lib/add'
        )
    },
    {
      path: 'update/:id',
      name: ConstantRouter.DASHBOARD_EXPERTS_LIB_UPDATE,
      component: () =>
        import(
          /* webpackChunkName: "dashboard-experts-lib-add" */ '@/dashboard/experts-lib/add'
        )
    },
    {
      path: 'detail/:id',
      name: ConstantRouter.DASHBOARD_EXPERTS_LIB_DETAIL,
      component: () =>
        import(
          /* webpackChunkName: "dashboard-experts-lib-detail" */ '@/dashboard/experts-lib/detail'
        )
    }
  ]
}

export default route
